import { awaitWrapper } from "@/common/utils/assist.js";
import {
    getOriTree, // 获取预算大类/预算类型等字典树(传7）
} from '../businessBudget/budgetDetail/tabPages/request.js'
import plus from 'library/functions/plus'
import minus from 'library/functions/minus'
import multiply from 'library/functions/multiply'
import divide from 'library/functions/divide'

export const getCellStyleByColumn = (executeRate, highlightProps = [], getTypeId = null) => { // executeRate: 执行率, highlightProps: 需要高亮的prop列表, getTypeId: 获取typeId的函数
    return ({ row, column }) => {
        const threshold = executeRate
        const value = row[column.property]

        if (value === null || value === undefined || value === '') {
            return {}
        }

        // 如果提供了自定义高亮prop列表，检查当前列是否在列表中
        if (highlightProps.length > 0) {
            if (highlightProps.includes(column.property)) {
                // 如果提供了 getTypeId 函数，使用 typeId 进行条件判断
                if (getTypeId) {
                    const typeId = getTypeId(row)
                    // typeId = 13 (收入行): value < threshold 高亮
                    // 其他 typeId: value > threshold 高亮
                    if (typeId === 13) {
                        if (value < threshold) {
                            return {
                                backgroundColor: '#f5bfc6'
                            }
                        }
                    } else {
                        if (value > threshold) {
                            return {
                                backgroundColor: '#f5bfc6'
                            }
                        }
                    }
                } else {
                    // 没有提供 getTypeId 函数时，使用默认逻辑（value > threshold 高亮）
                    if (value > threshold) {
                        return {
                            backgroundColor: '#f5bfc6'
                        }
                    }
                }
            }
        } else {
            // 保持原有逻辑作为默认行为
            if (column.property === 'businessIncomeVsRate' || column.property === 'grantIncomeVsRate') {
                if (value < threshold) {
                    return {
                        backgroundColor: '#f5bfc6'
                    }
                }
            }

            if (column.property === 'businessCostVsRate' || column.property === 'grantCostVsRate') {
                if (value > threshold) {
                    return {
                        backgroundColor: '#f5bfc6'
                    }
                }
            }
        }

        return {}
    }
}

export const reportStatusFilters = function (value) {
    switch (value) {
        case 0:
            return '未归档'
        case 1:
            return '已归档'
        default:
            return '--'
    }
}

// 获取预算大类
export const getBudgetTypeList = async (type) => {
    let [, res] = await awaitWrapper(getOriTree({
        dataType: type
    }))
    if (!res || res.code != 0) {
        return []
    }
    if (type == 7) {
        const budgetTypeList = res.data.tree || []
        const budgetTypeMap = {};
        (res.data.tree || []).forEach(item => {
            const dicId = item.dicName.toString().slice(0, 3)
            budgetTypeMap[dicId] = item.dicName
        })
        console.log('budgetTypeMap', budgetTypeMap)
        return {
            budgetTypeMap,
            budgetTypeList
        }
    }
}

// 提取并求和指定前缀和条件的字段
export const sumFieldsByPattern = (item, prefix, excludeSuffix = null, includeSuffix = null, excludeIds = [], excludeContains = null) => {
    let sum = 0
    for (let key in item) {
        if (key.startsWith(prefix)) {
            // 排除包含特定字符串的字段
            if (excludeContains && key.includes(excludeContains)) continue

            // 检查后缀条件（先检查，避免后续正则匹配问题）
            if (excludeSuffix && key.endsWith(excludeSuffix)) continue
            if (includeSuffix && !key.endsWith(includeSuffix)) continue

            // 提取ID部分（key的数字部分，可能在中间）
            // 修改正则：匹配前缀后的数字，不要求在末尾
            const keyWithoutPrefix = key.substring(prefix.length)
            const idMatch = keyWithoutPrefix.match(/^(\d+)/)
            if (!idMatch) continue

            const id = parseInt(idMatch[1])
            if (excludeIds.includes(id)) continue

            sum = plus(sum, (item[key] || 0))
        }
    }
    return sum
}

// 提取指定前缀的所有字段ID列表
export const extractFieldIds = (item, prefix, excludeSuffix = null, includeSuffix = null) => {
    const ids = []
    for (let key in item) {
        if (key.startsWith(prefix)) {
            const idMatch = key.match(/\d+$/)
            if (!idMatch) continue

            if (excludeSuffix && key.endsWith(excludeSuffix)) continue
            if (includeSuffix && !key.endsWith(includeSuffix)) continue

            const id = parseInt(idMatch[0])
            if (!ids.includes(id)) {
                ids.push(id)
            }
        }
    }
    return ids.sort((a, b) => a - b)
}

// 计算所有预算相关指标
export const calculateBudgetMetrics = (item) => {
    // 1. 业务预算
    const businessIncome = sumFieldsByPattern(item, 'businessIncome')
    const businessCost = sumFieldsByPattern(item, 'businessCost')
    const businessProfit = minus(businessIncome, businessCost)
    const businessProfitRate = businessIncome !== 0 ? multiply(divide(businessProfit, businessIncome), 100) : null

    // 2. 授予预算
    const grantIncome = sumFieldsByPattern(item, 'grantIncome')
    const grantCost = sumFieldsByPattern(item, 'grantCost')
    const grantProfit = minus(grantIncome, grantCost)
    const grantProfitRate = grantIncome !== 0 ? multiply(divide(grantProfit, grantIncome), 100) : null

    // 3. 实际执行（不包含Pre后缀，不包含Loan字段，成本费用排除100和101）
    const executeIncome = sumFieldsByPattern(item, 'executeIncome', 'Pre', null, [], 'Loan')
    const executeCost = sumFieldsByPattern(item, 'executeCost', 'Pre', null, [100, 101], 'Loan')
    const executeCostLoan = sumFieldsByPattern(item, 'executeCostLoan')
    const executeProfit = minus(minus(executeIncome, executeCost), executeCostLoan)
    const executeProfitRate = executeIncome !== 0 ? multiply(divide(executeProfit, executeIncome), 100) : null

    // 4. 去年同期实际执行（包含Pre后缀，不包含Loan字段，成本费用排除100和101）
    const executeIncomePre = sumFieldsByPattern(item, 'executeIncome', null, 'Pre', [], 'Loan')
    const executeCostPre = sumFieldsByPattern(item, 'executeCost', null, 'Pre', [100, 101], 'Loan')
    const executeProfitPre = minus(executeIncomePre, executeCostPre)
    const executeProfitRatePre = executeIncomePre !== 0 ? multiply(divide(executeProfitPre, executeIncomePre), 100) : null

    // 5. 业务预算执行率
    const businessIncomeVsRate = businessIncome !== 0 ? multiply(divide(executeIncome, businessIncome), 100) : null
    const businessCostVsRate = businessCost !== 0 ? multiply(divide(plus(executeCost, executeCostLoan), businessCost), 100) : null
    const businessProfitVsRate = businessProfit !== 0 ? multiply(divide(executeProfit, businessProfit), 100) : null

    // 6. 授予预算执行率
    const grantIncomeVsRate = grantIncome !== 0 ? multiply(divide(executeIncome, grantIncome), 100) : null
    const grantCostVsRate = grantCost !== 0 ? multiply(divide(plus(executeCost, executeCostLoan), grantCost), 100) : null
    const grantProfitVsRate = grantProfit !== 0 ? multiply(divide(executeProfit, grantProfit), 100) : null

    return {
        businessIncome,
        businessCost,
        businessProfit,
        businessProfitRate,
        grantIncome,
        grantCost,
        grantProfit,
        grantProfitRate,
        executeIncome,
        executeCost,
        executeCostLoan,
        executeProfit,
        executeProfitRate,
        executeIncomePre,
        executeCostPre,
        executeProfitPre,
        executeProfitRatePre,
        businessIncomeVsRate,
        businessCostVsRate,
        businessProfitVsRate,
        grantIncomeVsRate,
        grantCostVsRate,
        grantProfitVsRate
    }
}

// 计算合计行：将所有字段求和（排除合计行本身）
export const calculateSummaryRow = (dataList, summaryRowId = -1000009999) => {
    // 找到合计行
    let summaryRow = dataList.find(item => item.id === summaryRowId || item.firstDeptId === summaryRowId)

    // 如果没有找到，使用第一行作为合计行
    if (!summaryRow && dataList.length > 0) {
        summaryRow = dataList[0]
    }

    if (!summaryRow) {
        return null
    }

    // 获取其他所有行（排除合计行）
    const otherRows = dataList.filter(item =>
        (item.id !== summaryRowId && item.firstDeptId !== summaryRowId) &&
        item !== summaryRow
    )

    // 初始化合计对象
    const summary = {}

    // 遍历其他所有行，累加所有数值字段
    otherRows.forEach(row => {
        for (let key in row) {
            // 跳过非数值字段
            if (key === 'id' || key === 'firstDeptId' || key === 'firstDeptName' ||
                key === 'deptId' || key === 'deptName' || key === 'isEdit') {
                continue
            }

            const value = row[key]
            if (value !== null && value !== undefined && typeof value === 'number') {
                summary[key] = plus((summary[key] || 0), value)
            }
        }
    })

    // 更新合计行的所有字段
    Object.assign(summaryRow, summary)

    return summaryRow
}

/**
 * 处理总部按职能部门的数据计算
 * @param {Array} initTableData - 原始数据数组
 * @param {Number} executeRate - 执行率
 * @returns {Array} 处理后的数据数组
 */
export function processHeadquarterByDeptData(initTableData, executeRate) {
    if (!initTableData || initTableData.length === 0) {
        return []
    }

    // 处理每一行数据，计算衍生字段
    const processedData = initTableData.map(item => {
        const newItem = { ...item }

        // 1. 当年执行合计 = executeAmount + executeAmountLoan
        newItem.executeTotal = calculateSafePlus(item.executeAmount, item.executeAmountLoan)

        // 2. 当年执行合计（剔除待分摊）= executeTotal - executeAmountWaitShare
        newItem.executeTotalExcludeWaitShare = calculateSafeMinus(newItem.executeTotal, item.executeAmountWaitShare)

        // 3. 预算执行率 = executeTotal / businessAmount * 100
        newItem.budgetExecuteRate = calculateSafeDividePercent(newItem.executeTotal, item.businessAmount)

        // 4. 预算执行率（剔除待分摊）= executeTotalExcludeWaitShare / businessAmount * 100
        newItem.budgetExecuteRateExcludeWaitShare = calculateSafeDividePercent(newItem.executeTotalExcludeWaitShare, item.businessAmount)

        // 5. 同比变化（￥）= executeTotal - executeAmountPre
        newItem.yearOnYearChange = calculateSafeMinus(newItem.executeTotal, item.executeAmountPre)

        // 6. 同比变化（%）= yearOnYearChange / executeAmountPre * 100
        newItem.yearOnYearChangePercent = calculateSafeDividePercent(newItem.yearOnYearChange, item.executeAmountPre)

        return newItem
    })

    return processedData
}

/**
 * 安全的加法计算
 * @param {Number} a 
 * @param {Number} b 
 * @returns {Number}
 */
function calculateSafePlus(a, b) {
    // 加减法：如果空-空，则等于0
    if ((a === null || a === undefined) && (b === null || b === undefined)) {
        return 0
    }
    if (a === null || a === undefined) {
        a = 0
    }
    if (b === null || b === undefined) {
        b = 0
    }
    return plus(a, b)
}

/**
 * 安全的减法计算
 * @param {Number} a 
 * @param {Number} b 
 * @returns {Number}
 */
function calculateSafeMinus(a, b) {
    // 加减法：如果空-空，则等于0
    if ((a === null || a === undefined) && (b === null || b === undefined)) {
        return 0
    }
    a = a || 0
    b = b || 0
    return minus(a, b)
}

/**
 * 安全的乘法计算
 * @param {Number} a 
 * @param {Number} b 
 * @returns {Number|null}
 */
function calculateSafeMultiply(a, b) {
    if (a === null || a === undefined || b === null || b === undefined) {
        return null
    }
    return multiply(a, b)
}

/**
 * 安全的除法计算并转换为百分比
 * @param {Number} numerator - 分子
 * @param {Number} denominator - 分母
 * @returns {Number|null} 返回百分比数值，除法：分母为0，则返回null（展示"/"）
 */
function calculateSafeDividePercent(numerator, denominator) {
    // 除法：分母为0，则展示"/"
    if (denominator === null || denominator === undefined || denominator === 0) {
        return null
    }
    if (numerator === null || numerator === undefined) {
        return null
    }
    return multiply(divide(numerator, denominator), 100)
}

/**
 * 处理产品线数据的排序和计算
 * @param {Array} initTableData - 原始数据数组
 * @returns {Array} 处理后的数据数组
 */
export function processProductLineData(initTableData) {
    if (!initTableData || initTableData.length === 0) {
        return []
    }

    // 1. 按 firstDeptId 分组
    const grouped = {}
    initTableData.forEach(item => {
        const deptId = item.firstDeptId
        if (!grouped[deptId]) {
            grouped[deptId] = []
        }
        grouped[deptId].push(item)
    })

    // 2. 每组内按 typeSortSeq 升序排序
    Object.keys(grouped).forEach(deptId => {
        grouped[deptId].sort((a, b) => (a.typeSortSeq || 0) - (b.typeSortSeq || 0))
    })

    // 3. 提取特殊部门（放在末尾的4个部门）
    const specialDeptIds = [1000000000, 1000000010, 1000001020, 1000001030]
    const normalDepts = []
    const specialDepts = [null, null, null, null] // 预分配4个位置

    Object.keys(grouped).forEach(deptId => {
        const deptIdNum = Number(deptId)
        const items = grouped[deptId]

        if (specialDeptIds.includes(deptIdNum)) {
            // 找到特殊部门在数组中的位置
            const index = specialDeptIds.indexOf(deptIdNum)
            specialDepts[index] = items
        } else {
            normalDepts.push(...items)
        }
    })

    // 4. 组装最终数组：普通部门 + 4个特殊部门
    const flatSpecialDepts = specialDepts.filter(items => items !== null).flat()
    const allData = [...normalDepts, ...flatSpecialDepts]

    // 5. 计算衍生字段
    const processedData = allData.map(item => {
        const newItem = { ...item }

        // 当年执行合计 = executeAmount + executeAmountLoan
        newItem.executeTotal = calculateSafePlus(item.executeAmount, item.executeAmountLoan)

        // VS业务预算 = executeTotal / businessAmount * 100
        newItem.vsBusinessBudget = calculateSafeDividePercent(newItem.executeTotal, item.businessAmount)

        // VS授予预算 = executeTotal / grantAmount * 100
        newItem.vsGrantBudget = calculateSafeDividePercent(newItem.executeTotal, item.grantAmount)

        return newItem
    })

    return processedData
}
